// The optional message to the customer on a verdict email, with the email as it will be
// sent. Used by the Reject, Quote Ready and Consignment dialogs. The preview text comes
// from the worker's own email builder, so it cannot drift from the send.
// `preview` is null while loading, { error: true }, or { standard, before, after }.
// Fixed-height preview: typing a message must not resize the dialog.
export default function CustomerMessageBox({ id, value, onChange, preview, placeholder, toEmail, testId }) {
    const message = value.trim();
    return (
        <>
            <label htmlFor={id} style={{ display: 'block', marginTop: 'var(--space-4)', marginBottom: 'var(--space-2)' }}>Message to the customer (optional)</label>
            <textarea id={id} className="form-input" rows={3} maxLength={2000} placeholder={placeholder} value={value} onChange={e => onChange(e.target.value)} />
            <div style={{ marginTop: 'var(--space-4)', marginBottom: 'var(--space-2)' }}>Email preview{toEmail ? `, to ${toEmail}` : ''}</div>
            <div data-testid={testId} style={{ whiteSpace: 'pre-wrap', fontSize: 'var(--font-size-sm)', padding: 'var(--space-3)', height: '20em', overflowY: 'auto', background: 'var(--color-bg-secondary)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius)' }}>
                {!preview && 'Loading preview...'}
                {preview?.error && 'The preview could not be loaded. The email still sends as normal.'}
                {preview?.standard && (message
                    ? <>{preview.before}<mark>{message}</mark>{preview.after}</>
                    : preview.standard)}
            </div>
        </>
    );
}
